<template>
    <a-modal :visible="editorModalVisible" :confirm-loading="confirmLoading" width="580px" @cancel="handleCancel" :footer="null"
                title="项目">

         <a-form-model :model="modalData" ref="ruleForm" :rules="rules" :layout="formItemLayout"
                :label-col="labelCol" :wrapper-col="wrapperCol">

                <a-form-model-item ref="projectname" label="项目名" prop="projectname">
                    <a-input v-model="modalData.projectname" placeholder="如果是v5项目,其名称务以v5结尾" />
                </a-form-model-item>

                <a-form-model-item  label="svn目录" ref="svn" prop="svn">
                    <a-select show-search placeholder="指定trunk下目录" style="width: 200px" allow-clear v-model="modalData.svn">
                        <a-select-option v-for="(value,name) in svnData" :key="name" :value="name">
                        {{value}}
                        </a-select-option>
                    </a-select>
                </a-form-model-item>

                <a-form-model-item  label="所属领域" v-if="modalData.svn == 'JT' || modalData.svn == 'Java'" ref="level" prop="level">
                    <a-select show-search placeholder="请选择" style="width: 120px" allow-clear v-model="modalData.level">
                        <a-select-option v-for="(value,name) in levelData" :key="name" :value="name">
                        {{value}}
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
                

                <a-form-model-item ref="domain" label="域名" prop="domain">
                    <a-input v-model="modalData.domain"/>
                </a-form-model-item>
               
                <a-form-model-item :wrapper-col="{ span: 8, offset: 10 }">
                    <a-button type="primary" @click="handleOk">
                        保存
                    </a-button>
                    <a-button style="margin-left: 10px;" @click="handleCancel">
                        取消
                    </a-button>
                </a-form-model-item>
            </a-form-model>
    </a-modal>
</template>

<script>
export default{
    props:{
        svnData:Object,
        levelData:Object
    },
    data(){
        return {
            editorModalVisible:false,
            confirmLoading:false,  
            labelCol: { span: 6 },
            wrapperCol: { span:16 },
            formItemLayout:'horizontal',
            modalData:{
                id:'',
                domain:'',
                projectname:'',
                svn:'',
                level:''
            },
            rules: {
                projectname: [
                    {
                        trigger: 'blur',
                        validator: (rule, value, callback) => {
                            // var reg = /[^\u4e00-\u9fa5]/;
                            var reg = /[\u4E00-\u9FA5\uF900-\uFA2D]{1,}/;
                            if (value === "") {
                                callback(new Error("请输入项目名称"));
                            } else if (reg.test(value)) {
                                callback(new Error("项目名称不能为中文"));
                            } else {
                                callback();
                            }
                        }
                    },
                    { min: 1, max: 100, message: '请输入1~100个字符', trigger: 'blur' },
                ],
                level:[
                    { required: true, message: '请选择', trigger: 'blur' },
                ],
                svn:[
                    { required: true, message: '请输入SVN目录', trigger: 'blur' },
                    { min: 1, max: 100, message: '请输入1~100个字符', trigger: 'blur' },
                ],
            },
        }
    },
    methods:{
        init(item){
            if(item.id){
                this.modalData.id = item.id;
                this.modalData.domain = item.domain;
                this.modalData.projectname = item.projectname;
                this.modalData.svn = item.svn;
                this.modalData.level = item.level;
            }
            else{
                this.modalData = {
                    id:undefined,
                    domain:'',
                    projectname:'',
                    svn:'',
                    level:'',
                }
            }

            this.editorModalVisible = true;
        },
        handleOk() {
            let that = this;
            that.$refs.ruleForm.validate(valid => {
                if (valid) {
                    that.confirmLoading = true;
                    //处理list
                    if(that.modalData.id){
                        //编辑
                        that.$store.dispatch({
                            type: 'project/edit',
                            params: {
                                ...that.modalData,
                                updateuser:that.G.getCurrentUser().username,
                                urlparams:false,
                            }
                        }).then((res) => {
                            if (res.data.success == '1') {
                                that.handleCancel()
                                this.$emit('onModalHide')
                            }
                       
                        });
                    }
                    else {
                        //新增
                        that.$store.dispatch({
                            type: 'project/add',
                            params: {
                                ...that.modalData,
                                createuser:that.G.getCurrentUser().username,
                                status:JSON.stringify({
                                    svn:false
                                }),
                                urlparams:false,
                            }
                        }).then((res) => {
                            if (res.data.success == 1) {
                                that.handleCancel()
                                this.$emit('onModalHide')
                            }
                       
                        });
                    }
                    console.log(that.modalData)
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },
        handleCancel() {
            this.resetForm();
            this.editorModalVisible = false;
            
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
    }
}
</script>